import React, { useMemo } from "react"
import { Col, Row, CardTitle, Label, Input, Button } from "reactstrap"
import {
  checkExtension,
  formatAmount,
  renderAddressValue as renderCommunicationAddress,
  showRegistrationType,
} from "helpers/common"
import { Link, useNavigate } from "react-router-dom"
import pdfIcon from "../../../../assets/images/icons/file-type.svg"
import imageIcon from "../../../../assets/images/icons/image.svg"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"

import {
  useCompleteOnboardingInvestorMutation,
  useUpdateInvestorOnboardedStepMutation,
} from "store/api/wealthpartnerapi/onboard.api"
import { businessFiles } from "helpers/utils"

const OnboardFinalStep = ({ kycData }) => {
  const [kycFinalSubmission, { isLoading }] =
    useCompleteOnboardingInvestorMutation()
  const navigate = useNavigate()
  const [updateStep] = useUpdateInvestorOnboardedStepMutation()

  const goToStep = async (step) => {
    try {
      await updateStep({ kyc_status: step, id: kycData.investor_id }).unwrap()
      window.location.reload()
    } catch (error) {}
  }

  const submitForVerification = async () => {
    try {
      const { message, success } = await kycFinalSubmission({
        id: kycData.investor_id,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        navigate("/investor-management/onboard")
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const renderAddressValue = () => {
    if (kycData?.companyDetails?.business_address) {
      return kycData?.companyDetails?.business_address
    } else {
      let address = ""
      const addressOne = kycData?.companyDetails?.address_one
      const addressTwo = kycData?.companyDetails?.address_two
      const addressThree = kycData?.companyDetails?.address_three
      const city = kycData?.companyDetails?.city
      const state = kycData?.companyDetails?.state
      const pinCode = kycData?.companyDetails?.pin_code

      if (addressOne) {
        address = address.concat(addressOne, " ")
      }
      if (addressTwo) {
        address = address.concat(addressTwo, " ")
      }
      if (addressThree) {
        address = address.concat(addressThree, " ")
      }
      if (city) {
        address = address.concat(city, " ")
      }
      if (state) {
        address = address.concat(state, " ")
      }
      if (pinCode) {
        address = address.concat(pinCode)
      }

      return address
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          marginTop: "6rem",
          paddingInline: "2rem",
        }}
      >
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mt-4 mb-4 justify-content-between">
                  <CardTitle className="">Entity Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Name of the Entity</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.companyDetails?.entity_name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Date of Incorporation
                    </Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.companyDetails?.date_of_incorporation}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Constitution of Business
                    </Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.companyDetails?.constitution_of_business}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Registered Address</Label>
                    <Input
                      disabled
                      name="name"
                      type="textarea"
                      className="form-control"
                      value={renderAddressValue()}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Communication Address
                    </Label>
                    <Input
                      disabled
                      name="name"
                      type="textarea"
                      className="form-control"
                      value={
                        kycData?.companyDetails?.is_comm_address_same === "SAME"
                          ? renderAddressValue()
                          : renderCommunicationAddress(
                              kycData?.companyDetails?.communication_address
                            )
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">PAN</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.investor?.pan_no}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">GSTIN</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.companyDetails?.gstin || "Not Applicable"}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Phone No.</Label>
                    <Input
                      disabled
                      name="phone"
                      type="text"
                      className="form-control"
                      value={kycData?.investor?.phone}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Email Address</Label>
                    <Input
                      disabled
                      name="email"
                      type="text"
                      className="form-control"
                      value={kycData?.investor?.email}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Political Exposure</Label>
                    <Input
                      disabled
                      name="politicalExposure"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.companyAdditionalDetails?.politicalExposure
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Entity Registration No.(
                      {showRegistrationType(
                        kycData?.companyAdditionalDetails
                          ?.constitution_of_business
                      )}
                      )
                    </Label>
                    <Input
                      disabled
                      name="email"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.companyAdditionalDetails
                          ?.entity_registration_no
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Bank Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Account Holders Name
                    </Label>
                    <Input
                      disabled
                      name="account_holder"
                      type="text"
                      className="form-control"
                      value={kycData?.bankDetails?.account_holder}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Number</Label>
                    <Input
                      disabled
                      name="account_no"
                      type="text"
                      className="form-control"
                      value={kycData?.bankDetails?.account_no}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Bank Name</Label>
                    <Input
                      disabled
                      name="bank_name"
                      type="text"
                      className="form-control"
                      value={kycData?.bankDetails?.bank_name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">IFSC</Label>
                    <Input
                      disabled
                      name="ifsc"
                      type="text"
                      className="form-control"
                      value={kycData?.bankDetails?.ifsc}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Type</Label>
                    <Input
                      disabled
                      name="account_type"
                      type="text"
                      className="form-control"
                      value={kycData?.bankDetails?.account_type}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Authorised Person Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Designation</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={kycData?.companyAdditionalDetails?.designation}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">DIN</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.companyAdditionalDetails?.dpin ??
                        "Not Applicable"
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          {kycData?.agreementDetails && (
            <Row>
              <Col xl={12}>
                <div>
                  <div>
                    <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                      <CardTitle className="">ICD Details</CardTitle>
                    </div>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          ICD Tenure (in Months)
                        </Label>
                        <Input
                          disabled
                          name="account_holder"
                          type="text"
                          className="form-control"
                          value={kycData?.agreementDetails?.tenure}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Proposed ICD Amount
                        </Label>
                        <Input
                          disabled
                          name="account_no"
                          type="text"
                          className="form-control"
                          value={`₹ ${formatAmount(
                            kycData?.agreementDetails?.amount
                          )}`}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Row>

        <Row>
          <Col xl={12}>
            <CardTitle className="mt-4 mb-4">Documents</CardTitle>

            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Entity Documents
            </CardTitle>
            <div className="documents-section">
              {kycData?.companyDetails?.pan_image && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(kycData?.companyDetails.pan_image) ===
                    "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>PAN</p>
                      <Link
                        to={`${process.env.REACT_APP_FILE_URL}/gst/${kycData?.companyDetails?.pan_image}`}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              )}
              {businessFiles.map((item, index) => (
                <React.Fragment key={`businessFiles_${index}`}>
                  {kycData?.companyAdditionalDetails?.[item.key] && (
                    <div className="documents-box">
                      <div className="file-type">
                        <img src={pdfIcon} alt="" />
                        <div>
                          <p>{item.label}</p>
                          <Link
                            to={`${process.env.REACT_APP_FILE_URL}/businessDocs/${kycData?.companyAdditionalDetails?.[item.key]}`}
                            target="_blank"
                          >
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <div className="verified-user">
                          <img src={check} alt="" /> Verified
                        </div> */}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>

            <hr className="my-4" />
            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Authorised Person Documents
            </CardTitle>
            <div className="documents-section">
              {kycData?.companyAdditionalDetails?.authority_letter && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.companyAdditionalDetails?.authority_letter
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Authority Letter</p>
                      <Link
                        to={`${process.env.REACT_APP_FILE_URL}/businessDocs/${kycData?.companyAdditionalDetails?.authority_letter}`}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <hr className="my-4" />
            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Banking Documents
            </CardTitle>
            <div className="documents-section">
              {kycData?.bankDetails?.cheque_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(kycData?.bankDetails.cheque_file) ===
                    "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Cheque</p>
                      <Link
                        to={`${process.env.REACT_APP_FILE_URL}/cheques/${kycData?.bankDetails?.cheque_file}`}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
            </div>
            <div className="buttons">
              <Button
                type="button"
                className="btn btn-primary w-md"
                disabled={isLoading}
                onClick={() => submitForVerification()}
              >
                {isLoading ? <Spinners /> : "Submit for Verification"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default OnboardFinalStep
